import { encode } from 'html-entities';

import { uri, isset } from 'utils';

import { HEADER_SEARCH_QUERY_PARAMETER_ID } from '../../search/constants';
import { getURLParamsFromActiveFilters } from '.';

import {
    LISTING_PAGE_URL_PARAMETER,
    LISTING_FIRST_PAGE,
    LISTING_SORTING_URL_PARAMETER
} from '../constants';

/**
 * @param {string | number} value
 * @returns {string}
 */
const normalizeURLValue = value => value.toString();

/**
 * @typedef  Params
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {types.AdvancedFilter[]} advancedFilters
 * @property {number} page
 * @property {string} searchValue
 * @property {string} selectedSorting
 * @property {boolean} [replaceState]
 */

/**
 * @param {Params}
 * @returns {void}
 */
const setListingStateToURL = ({
    filters = [],
    advancedFilters = [],
    page,
    searchValue = '',
    selectedSorting = '',
    replaceState = false
}) => {
    const query = getURLParamsFromActiveFilters([
        ...filters,
        ...advancedFilters
    ]);

    if (searchValue) {
        query[HEADER_SEARCH_QUERY_PARAMETER_ID] = encode(searchValue);
    }

    if (selectedSorting) {
        query[LISTING_SORTING_URL_PARAMETER] = normalizeURLValue(
            selectedSorting
        );
    }

    // do not append ?page=1 to URL, it would cause SEO duplicit content
    if (isset(page) && !Number.isNaN(page) && page > LISTING_FIRST_PAGE) {
        query[LISTING_PAGE_URL_PARAMETER] = normalizeURLValue(page);
    }

    const formattedURL = uri.format({ query });

    // no need to update (write into Browser history)
    if (formattedURL === window.location.search) {
        return;
    }

    const queryIsEmpty = Object.keys(query).length === 0;

    const finalFormattedURL = queryIsEmpty
        ? window.location.pathname // remove '?' from URL if query is empty
        : formattedURL; // set net parameters

    if (replaceState) {
        uri.replaceURL(finalFormattedURL);
    } else {
        uri.setLocation(finalFormattedURL);
    }
};

export default setListingStateToURL;
